import { useState, useEffect } from 'react'
import { FiTrash2, FiEdit2, FiX } from 'react-icons/fi'
import { FaEye } from 'react-icons/fa'
import AuthImage from '../AuthImage/AuthImage'
import './PhotoGallery.css'

function PhotoGallery({ photos, imageBasePath = '/images/generator', onEdit, onRemove, emptyText = 'Nenhuma foto adicionada ainda.' }) {
    const [lightboxPhoto, setLightboxPhoto] = useState(null)

    useEffect(() => {
        if (!lightboxPhoto) return
        const onKey = (e) => { if (e.key === 'Escape') setLightboxPhoto(null) }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [lightboxPhoto])

    const list = photos || []

    return (
        <>
            <div className="phg-grid">
                {list.map((photo) => (
                    <div key={photo._id} className="phg-card">
                        <div className="phg-thumb-wrap" onClick={() => setLightboxPhoto(photo)}>
                            <AuthImage
                                className="phg-thumb"
                                src={`${imageBasePath}/${photo.filename}`}
                                alt={photo.description || 'Foto'}
                            />
                            <div className="phg-thumb-overlay">
                                <span className="phg-eye-frame">
                                    <FaEye size={26} />
                                </span>
                            </div>
                        </div>
                        <p className="phg-desc">{photo.description || 'Sem descrição'}</p>
                        {(onEdit || onRemove) && (
                            <div className="phg-actions">
                                {onEdit && (
                                    <button type="button" className="phg-edit" onClick={() => onEdit(photo)}>
                                        <FiEdit2 size={13} />
                                        <span>Editar</span>
                                    </button>
                                )}
                                {onRemove && (
                                    <button type="button" className="phg-remove" onClick={() => onRemove(photo)}>
                                        <FiTrash2 size={13} />
                                        <span>Remover</span>
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                ))}
                {list.length === 0 && (
                    <p className="phg-empty">{emptyText}</p>
                )}
            </div>

            {lightboxPhoto && (
                <div className="phg-lightbox-overlay" onClick={() => setLightboxPhoto(null)}>
                    <button type="button" className="phg-lightbox-close" onClick={() => setLightboxPhoto(null)}>
                        <FiX size={22} />
                    </button>
                    <AuthImage
                        className="phg-lightbox-img"
                        src={`${imageBasePath}/${lightboxPhoto.filename}`}
                        alt={lightboxPhoto.description || 'Foto'}
                        onClick={(e) => e.stopPropagation()}
                    />
                    {lightboxPhoto.description && (
                        <p className="phg-lightbox-desc" onClick={(e) => e.stopPropagation()}>
                            {lightboxPhoto.description}
                        </p>
                    )}
                </div>
            )}
        </>
    )
}

export default PhotoGallery
